// Default (system) assessments
export const FETCH_DEFAULT_ASSESSMENTS = 'adminAssessment/FETCH_DEFAULT_ASSESSMENTS';
export const FETCH_DEFAULT_ASSESSMENTS_SUCCESS = 'adminAssessment/FETCH_DEFAULT_ASSESSMENTS_SUCCESS';
export const FETCH_DEFAULT_ASSESSMENTS_ERROR = 'adminAssessment/FETCH_DEFAULT_ASSESSMENTS_ERROR';

// My (trainer) custom assessments
export const FETCH_MY_ASSESSMENTS = 'adminAssessment/FETCH_MY_ASSESSMENTS';
export const FETCH_MY_ASSESSMENTS_SUCCESS = 'adminAssessment/FETCH_MY_ASSESSMENTS_SUCCESS';
export const FETCH_MY_ASSESSMENTS_ERROR = 'adminAssessment/FETCH_MY_ASSESSMENTS_ERROR';

// Create / Update / Delete
export const CREATE_ASSESSMENT = 'adminAssessment/CREATE_ASSESSMENT';
export const CREATE_ASSESSMENT_SUCCESS = 'adminAssessment/CREATE_ASSESSMENT_SUCCESS';
export const CREATE_ASSESSMENT_ERROR = 'adminAssessment/CREATE_ASSESSMENT_ERROR';
export const UPDATE_ASSESSMENT = 'adminAssessment/UPDATE_ASSESSMENT';
export const UPDATE_ASSESSMENT_SUCCESS = 'adminAssessment/UPDATE_ASSESSMENT_SUCCESS';
export const UPDATE_ASSESSMENT_ERROR = 'adminAssessment/UPDATE_ASSESSMENT_ERROR';
export const DELETE_ASSESSMENT = 'adminAssessment/DELETE_ASSESSMENT';
export const DELETE_ASSESSMENT_SUCCESS = 'adminAssessment/DELETE_ASSESSMENT_SUCCESS';
export const DELETE_ASSESSMENT_ERROR = 'adminAssessment/DELETE_ASSESSMENT_ERROR';

// Clear create/update/delete error
export const CLEAR_ASSESSMENT_ERROR = 'adminAssessment/CLEAR_ASSESSMENT_ERROR';
